// The browser tab's title (Owner, 2026-10-05): the app, a separator, then
// the page, "metricsIQ Commerce | All Customers". The mDecide apps write
// theirs the same way ("mDecide Portfolio | Dashboards").
import { useEffect } from 'react';

/** The app's name, first in every tab. */
export const APP_TITLE = 'metricsIQ Commerce';
/** Between the app's name and the page's. */
export const TITLE_SEPARATOR = ' | ';

export function documentTitle(page?: string | null): string {
  const name = page?.trim();
  return name ? `${APP_TITLE}${TITLE_SEPARATOR}${name}` : APP_TITLE;
}

/** Keep the tab's title on this page while it is mounted. */
export function useDocumentTitle(page?: string | null): void {
  useEffect(() => {
    document.title = documentTitle(page);
  }, [page]);
}
